<template>
    <b-container class="text-center">
        <b-row>
            <b-col
                    sm="12"
                    lg="5"
            >
                <hr
                        v-if="!isMobile"
                        class="bar top-bar"
                >

                <div class="with-your-home text-sm-center text-lg-left">
                    Homeowner benefits
                </div>

                <div>
                    <b-row class="items-list d-inline-block d-lg-flex">
                        <b-col>
                            <div class="item">
                                <i class="icon fas fa-chart-line"/> Track your home value and equity
                            </div>

                            <div class="item">
                                <i class="icon far fa-graduation-cap"/> Learn how to manage your home
                            </div>

                            <div class="item">
                                <i class="icon far fa-folders"/> Centralize home-related info
                            </div>

                            <div class="item">
                                <i class="icon far fa-tools"/> Get home services
                            </div>

                            <div class="item">
                                <i class="icon far fa-comments-alt"/> Ask me questions and get help
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <hr
                        class="bar bottom-bar"
                        v-if="!isMobile"
                >
            </b-col>

            <b-col
                    sm="12"
                    lg="7"
            >
                <div class="video-wrapper">
                    <div class="video-body">
                        <b-embed
                                type="iframe"
                                :src="homeOwnershipDescriptiveVideoUrl"
                                allowfullscreen
                        />
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import "./HomeOwnershipHomeBody.scss";
import VimeoMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/VimeoMixin";
import "./HomeOwnershipHomeBody.mobile.scss";
import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";

export default {
    name: "HomeOwnershipHomeBody",

    mixins: [
        VimeoMixin,
        IsMobileMixin
    ],

    computed: {
        homeOwnershipDescriptiveVideoUrl() {
            return this.getVimeoUrl(window.env.HOME_OWNERSHIP_DESCRIPTIVE_VIDEO_ID);
        },
    }
};
</script>